const lm = window.LinkMink;
export const linkmink = lm("pub_live_l0UpegTPhrjZ87soLxwA");
